/**
 * Simpatico Bikes - My Account JavaScript (Vanilla)
 * Handles AJAX operations and interactive elements without jQuery
 */

(function() {
	'use strict';

	/**
	 * Initialize on document ready
	 */
	function init() {
		bindEvents();
		initFileUploads();
	}

	/**
	 * Bind event listeners
	 */
	function bindEvents() {
		// Delete bike confirmation
		document.addEventListener('click', function(e) {
			if (e.target.classList.contains('delete-bike-btn') || e.target.closest('.delete-bike-btn')) {
				handleDeleteBike(e);
			}
		});

		// File upload preview
		document.addEventListener('change', function(e) {
			if (e.target.type === 'file') {
				handleFileSelect(e);
			}
		});

		// Form validation
		const forms = document.querySelectorAll('.simpatico-form form');
		forms.forEach(form => {
			form.addEventListener('submit', validateForm);
		});
	}

	/**
	 * Handle bike deletion
	 */
	function handleDeleteBike(e) {
		e.preventDefault();

		const button = e.target.classList.contains('delete-bike-btn')
			? e.target
			: e.target.closest('.delete-bike-btn');

		const bikeId = button.dataset.bikeId;
		const bikeName = button.dataset.bikeName || 'this bike';

		if (!confirm('Are you sure you want to delete ' + bikeName + '? This action cannot be undone.')) {
			return;
		}

		button.disabled = true;
		button.textContent = 'Deleting...';

		const formData = new FormData();
		formData.append('action', 'simpatico_delete_bike');
		formData.append('bike_id', bikeId);
		formData.append('nonce', simpatico_ajax.nonce);

		fetch(simpatico_ajax.ajax_url, {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				// Remove the bike card from DOM
				const bikeCard = button.closest('.bike-card');
				bikeCard.style.opacity = '0';
				bikeCard.style.transition = 'opacity 0.3s ease';

				setTimeout(() => {
					bikeCard.remove();

					// Check if no bikes left
					const bikesGrid = document.querySelector('.bikes-grid');
					if (bikesGrid && bikesGrid.querySelectorAll('.bike-card').length === 0) {
						location.reload();
					}
				}, 300);
			} else {
				alert(data.data.message || 'Failed to delete bike. Please try again.');
				button.disabled = false;
				button.textContent = 'Delete';
			}
		})
		.catch(error => {
			console.error('Delete bike error:', error);
			alert('An error occurred. Please try again.');
			button.disabled = false;
			button.textContent = 'Delete';
		});
	}

	/**
	 * Handle file selection and preview
	 */
	function handleFileSelect(e) {
		const input = e.target;
		const wrapper = input.closest('.file-upload');
		const label = wrapper ? wrapper.querySelector('.file-upload-label') : null;
		const files = input.files;

		if (!label || !files || files.length === 0) return;

		const fileNames = [];
		let hasError = false;
		const maxSize = 5 * 1024 * 1024; // 5MB

		for (let i = 0; i < files.length; i++) {
			const file = files[i];

			// Check file size
			if (file.size > maxSize) {
				alert('File "' + file.name + '" is too large. Maximum size is 5MB.');
				hasError = true;
				break;
			}

			fileNames.push(file.name);
		}

		if (!hasError) {
			// Save original HTML if not already saved
			if (!label.dataset.originalHtml) {
				label.dataset.originalHtml = label.innerHTML;
			}

			// Update label with file names
			const fileListHtml =
				'<div class="selected-files">' +
				'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
				'<path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>' +
				'</svg>' +
				'<span>' + fileNames.join(', ') + '</span>' +
				'</div>';

			label.innerHTML = fileListHtml;
			label.classList.add('has-files');
		} else {
			// Clear the input
			input.value = '';
		}
	}

	/**
	 * Initialize file upload labels
	 */
	function initFileUploads() {
		const labels = document.querySelectorAll('.file-upload-label');
		labels.forEach(label => {
			label.dataset.originalHtml = label.innerHTML;
		});
	}

	/**
	 * Form validation
	 */
	function validateForm(e) {
		const form = e.target;
		let isValid = true;
		let firstError = null;

		// Check required fields
		const requiredFields = form.querySelectorAll('[required]');
		requiredFields.forEach(field => {
			const value = field.value;

			if (!value || (typeof value === 'string' && value.trim() === '')) {
				isValid = false;
				field.classList.add('error');

				if (!firstError) {
					firstError = field;
				}
			} else {
				field.classList.remove('error');
			}
		});

		if (!isValid) {
			e.preventDefault();

			if (firstError) {
				firstError.focus();
			}

			alert('Please fill in all required fields.');
			return false;
		}

		// Show loading state on submit button
		const submitBtn = form.querySelector('button[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = true;
			const originalText = submitBtn.textContent;
			submitBtn.textContent = 'Submitting...';

			// Re-enable if form doesn't actually submit (for debugging)
			setTimeout(() => {
				submitBtn.disabled = false;
				submitBtn.textContent = originalText;
			}, 10000);
		}

		return true;
	}

	// Run on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

})();
